import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Footer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);
  const [disappearBtn, setDisappearBtn] = useState(false);
  useEffect(() => {
    const handleShowButton = () => {
      if (window.scrollY > 450) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
    window.addEventListener('scroll', handleShowButton);
    return () => {
      window.removeEventListener('scroll', handleShowButton);
    };
  }, []);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    if (pathname !== '/') {
      setDisappearBtn(true);
    } else {
      setDisappearBtn(false);
    }
  }, [pathname]);

  return (
    <footer className="Footer">
      <div className="inner">
        <div className="top flex">
          <div className="footerLogo">
            <Link to="/">
              <img src="/images/logo/logo_footer.png" alt="" className="pc" />
              <img src="/images/logo/logo_footer800.png" alt="" className="m800" />{' '}
            </Link>
          </div>
          <div className="essential">
            <ul className="footerInquiry flex">
              <li>
                <Link to="/contact-us/product/contact-us">제품문의</Link>
              </li>
              <li>
                <Link to="/contact-us/partner/contact-us">제휴문의</Link>
              </li>
            </ul>
            <ul className="policy flex">
              <li>
                <button
                  type="link"
                  onClick={() => {
                    window.open(
                      '/popup/term-personal',
                      'window',
                      'width=500, height=700, location=no, status=no, scrollbars=yes',
                    );
                  }}
                >
                  개인정보처리방침
                </button>
              </li>
              <li>
                <button
                  type="link"
                  onClick={() => {
                    window.open(
                      '/popup/term-email',
                      'window',
                      'width=500, height=600, location=no, status=no, scrollbars=yes',
                    );
                  }}
                >
                  이메일주소무단수집거부
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="bottom">
          <ul className="address">
            <li>부산광역시 해운대구 센텀중앙로 90 605호</li>
            <li>(605 Room, 90, Centum jungang-ro, Haeundae-gu, Busan, Republic of Korea)</li>
          </ul>
          <div className="contactCopy flex">
            <ul className="flex">
              <li>
                <a href="tel:051-781-8787"> TEL : 051.781.8787</a>
              </li>
              <li>FAX : 02.0685.4330</li>
              <li>
                <a href="mailto:jtchoi@withus.cc">E-mail : jtchoi@withus.cc</a>
              </li>
            </ul>
            <div className="copyright">
              COPYRIGHT&copy;2023 withus security all rights reserved.
            </div>
          </div>
        </div>
        <div className={showButton ? 'toTop on' : 'toTop'}>
          <button onClick={toTop}>
            <img src="/images/icon/top_icon.png" alt="" className="pc" />
            <img src="/images/icon/top_icon_800.png" alt="" className="w800" />
          </button>
        </div>
        <div className={disappearBtn ? 'contactUs on' : 'contactUs'}>
          <button onClick={() => navigate('/contact-us/partner/contact-us')}>
            <img src="/images/icon/contact_icon.png" alt="" className="pc" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
